import React, { Component } from "react";
import { HomepageContext } from "context/homepageProvider";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import MachineStatusOverview from "./machineStatusOverview";
import ServiceSummary from "./serviceSummary";
import TopClaimAndChannel from "./topClaimAndChannel";
import LetterLoading from "components/loading/letterLoading";
import "scss/screens/homepage/homepage.scss";

export default class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  async componentDidMount() {
    this.startLoading();
    await this.setDataDefault();
    this.stopLoading();
    // setTimeout(() => this.stopLoading(), 1000);
  }

  setDataDefault = async () => {
    const { getMachineStatusOverview, getServiceSummary, getTopClaim } = this.context;
    await getMachineStatusOverview({ model: "" });
    await getServiceSummary({
      min_date: null,
      max_date: null,
      pic: "",
      model: "",
    });
    await getTopClaim({ min_date: null, max_date: null, model: null });
  };

  render() {
    const { isLoading } = this.state;

    return (
      <div className="homepage">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="dashboard" />
        <Navigation />
        <div className="homepage-content">
          <h2>สถานะต่างๆ ของเครื่องจักรทั้งหมด</h2>
          {/* <h2>1. Machine Status Overview</h2> */}
          <hr />
          <div className="homepage-content-machine">
            <MachineStatusOverview />
          </div>
          <h2>Service Summary</h2>
          {/* <h2>2. Service Summary</h2> */}
          <hr />
          <div className="homepage-content-service">
            <ServiceSummary />
          </div>
          <h2>Top Claim & Channel</h2>
          {/* <h2>3. Top Claim & Channel</h2> */}
          <hr />
          <div className="homepage-content-claim">
            <TopClaimAndChannel />
          </div>
        </div>
      </div>
    );
  }
}

Homepage.contextType = HomepageContext;
